import React, { useState, useEffect } from 'react';
import DetailsText from './DetailsText'
import ResultText from '../Result/ResultText';


import './styles.css'

export default function Result({history}) {
    
    const [number, setNumber] = useState('');
    const [typeAndName, setTypeAndName] = useState('');
    const [getedType, setGetedType] = useState(false);

    function getHashParams() {
        var url = new URL(window.location.href);
        var numberParam = url.searchParams.get("type") || -1;
        console.log(numberParam)
        if(numberParam == -1){
            setNumber(localStorage.getItem("number"))
            setTypeAndName(localStorage.getItem("typeAndName"))
        } else {
            setNumber(numberParam)
            setTypeAndName(ResultText.type_and_name[numberParam - 1])
        }
        setGetedType(true)
        console.log(number)
        console.log(typeAndName)
    }

    useEffect(() => {
        if (!getedType) {
            getHashParams()
        }
      }, [getedType])

      function goToHome(){
        history.push('/types')
      }

    return(
        <div>
            <div onClick={goToHome} className='container-arrow'>
                <i className="left"></i>
                <p className='text-back'>Voltar</p>
            </div>
			<p className="title-page"> PERFIL </p>
            <p className="result-name"> {typeAndName} </p>
			<p className="title-detail-type"> Características Positivas </p>
			<p className="description-detail-type"> {DetailsText.posite_points[number - 1]} </p>
            <p className="title-detail-type"> Características Negativas </p>
			<p className="description-detail-type"> {DetailsText.negative_points[number - 1]} </p>
            <p className="title-detail-type"> Pontos Positivos </p>
			<p className="description-detail-type"> {DetailsText.positive_resume[number - 1]} </p>
            <p className="title-detail-type"> Pontos Negativos </p>
			<p className="description-detail-type"> {DetailsText.negative_resume[number - 1]} </p>
            <p className="title-detail-type"> Áreas de Atuação </p>
			<p className="description-detail-type"> {DetailsText.actuation_field[number - 1]} </p>
            <p className="title-detail-type"> Pontos de Estresse e de Segurança </p>
			<p className="description-detail-type"> {DetailsText.attention[number - 1]} </p>
            <p className="title-detail-type"> Pontos de Atenção e Melhoria </p>
			<p className="description-detail-type"> {DetailsText.attention_part_2[number - 1]} </p>
            <p className="title-detail-type"> Pessoas deste tipo </p>
			<p className="description-detail-type"> {DetailsText.people[number - 1]} </p>
            <p className="title-detail-type"> Escutar música sobre o perfil </p>
            <iframe title='eneagramn-song' className = 'video' width="100%" height="315" src={DetailsText.videos[number - 1]} 
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; 
            picture-in-picture" allowfullscreen='true'></iframe>
        </div>
    );
}